import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "done",
  "use": "done-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"done\">\n<path d=\"M7.5 0.5C3.34375 0.5 0 3.875 0 8C0 12.1562 3.34375 15.5 7.5 15.5C11.625 15.5 15 12.1562 15 8C15 3.875 11.625 0.5 7.5 0.5ZM11.0938 6.625L7.09375 10.625C6.9375 10.8125 6.71875 10.875 6.5 10.875C6.25 10.875 6.03125 10.8125 5.875 10.625L3.875 8.625C3.53125 8.28125 3.53125 7.75 3.875 7.40625C4.21875 7.0625 4.75 7.0625 5.09375 7.40625L6.5 8.78125L9.875 5.40625C10.2188 5.0625 10.75 5.0625 11.0938 5.40625C11.4375 5.75 11.4375 6.28125 11.0938 6.625Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/done.svg
// module id = p0yd
// module chunks = 13